"use client";

import React from "react";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/material";
import theme from "../Theme";
import ReactQueryProvider from "./ReactQueryProvider";

type Props = {
  children: React.ReactNode;
};

const Wrapper = ({ children }: Props) => {
  return (
    <ReactQueryProvider>
      <QueryErrorResetBoundary>
        {/* <SocketNotificationWrapper> */}
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
        {/* </SocketNotificationWrapper> */}
        <ToastContainer />
      </QueryErrorResetBoundary>
    </ReactQueryProvider>
  );
};

export default Wrapper;
